const getFromLocalStorage = (key) => {
    const value = localStorage.getItem(key);
    if (value) {
        return value;
    } else {
        console.log(`Key "${key}" not found in localStorage`);
        return null;
    }
}

export default getFromLocalStorage;
